import { render, staticRenderFns } from "./TabellaProdottoAssicurativoMandato.vue?vue&type=template&id=1a921321&scoped=true"
import script from "./TabellaProdottoAssicurativoMandato.vue?vue&type=script&lang=js"
export * from "./TabellaProdottoAssicurativoMandato.vue?vue&type=script&lang=js"
import style0 from "./TabellaProdottoAssicurativoMandato.vue?vue&type=style&index=0&id=1a921321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a921321",
  null
  
)

export default component.exports